export const GET_USER_LIST = 'GET_USER_LIST'
export const ERROR_USER_LIST = 'ERROR_USER_LIST'
export const GET_USER_BY_ID = 'GET_USER_BY_ID'
export const ERROR_USER_BY_ID = 'ERROR_USER_BY_ID'
export const GET_USER_DEVICES_BY_ID = 'GET_USER_DEVICES_BY_ID'
export const ERROR_USER_DEVICES_BY_ID = 'ERROR_USER_DEVICES_BY_ID'
export const CLEAR_USER_DEVICES_BY_ID = 'CLEAR_USER_DEVICES_BY_ID'

export const CLEAR_USER_MANAGEMENT = 'CLEAR_USER_MANAGEMENT'